export default __webpack_public_path__ + "media/icons/videos-icon-70b2aaf4.svg";